/**
 * Copies each table header into data-label on matching body cells
 * so CSS can render Label : Value card rows on small screens.
 */
export function syncTableDataLabels(root = document) {
  const tables = root.querySelectorAll('table.table');

  tables.forEach((table) => {
    const headers = Array.from(table.querySelectorAll('thead th')).map((th) =>
      (th.textContent || '').replace(/\s+/g, ' ').trim()
    );

    if (!headers.length) return;

    table.querySelectorAll('tbody tr').forEach((row) => {
      const cells = Array.from(row.querySelectorAll('td'));
      const isFullSpan =
        cells.length === 1 && cells[0].hasAttribute('colspan');

      if (isFullSpan) {
        cells[0].removeAttribute('data-label');
        return;
      }

      cells.forEach((cell, index) => {
        const label = headers[index];
        if (label) {
          cell.setAttribute('data-label', label);
        } else {
          cell.removeAttribute('data-label');
        }
      });
    });
  });
}
